import React, { useContext, useEffect, useState } from "react";
import ChooseDeviceField from "./ChooseDeviceField";
//import ChangesDropdown from "./ChangesDropdown";
import RemediationTableSearchSection from "./RemediationTableSearchSection"
//import ValidationResultTableSearchSection from "../ValidationResultTableSearchSection";
//import HighlightManagement from "./HighlightManagement";
import * as deviceService from "../../devices/deviceService";
import { getFilters } from "../../view/urlService";
import { TableContext } from "../../index";
// import SearchInputV2 from "../../view/SearchInputV2";
// import { useHistory } from "react-router-dom";

export function RemediationTableManagement() {

  const { setConfig } = useContext(TableContext);
  // const history = useHistory();
  const [deviceId, setDeviceId] = useState();
  const [pageData, setPageData] = useState({});

  // const [searchTerm, setSearchTerm] = useState(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   return params.get('rule') || '';
  // });

  // const handleSearch = (e) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);

  //   if (value) {
  //     history.replace({
  //       pathname: history.pathname,
  //       search: addSearchFilters('rule', value),
  //     });
  //   } else {
  //     history.replace({
  //       pathname: history.pathname,
  //       search: removeFilter('rule'),
  //     });
  //   }
  // };

  const fetchData = async () => {
    try {
      const deviceList = await deviceService.list();
      const pageFilters = getFilters(true);

      let device;

      if (pageFilters.device) {
        device = deviceList.find(device => device.hostName === pageFilters.device);
      }

      if (device) {
        setDeviceId(device.id);
      }

      setConfig(prev => ({
        ...prev,
        ...(device ? { deviceId: device.id } : {}),
        filtersLoading: false
      }));
      setPageData({ deviceList });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  return (
    <div className="oct_filter-section-v2" id="RemediationTableManagement">
      {/* Row 1: Device Type & Choose Device */}
      <div className="row mb-3">
        <div className="col">
          <label className="oct_filter-label">Choose Device</label>
          <ChooseDeviceField
            setDeviceId={setDeviceId}
            deviceId={deviceId}
            devices={pageData.deviceList} />
        </div>

        <div className="col">
          <RemediationTableSearchSection />
        </div>
      </div>

      {/* Row 2: Search Section */}
      {/* <div className="mb-3">
        <div>
          <SearchInputV2
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Search by rule name..."
            className="m-0"
          />
        </div>
      </div> */}
    </div>
  )

}


export default RemediationTableManagement;
